export default {
  'app.pwa.offline': 'Vous êtes actuellement hors ligne',
  'app.pwa.serviceworker.updated': 'Un nouveau contenu est disponible',
  'app.pwa.serviceworker.updated.hint':
    'Veuillez cliquer sur le bouton « Rafraîchir » pour recharger la page actuelle',
  'app.pwa.serviceworker.updated.ok': 'Rafraîchir',
  'app.updateCheck.title': 'Vérification des mises à jour',
  'app.updateCheck.backend': 'Backend',
  'app.updateCheck.frontend': 'Frontend',
  'app.updateCheck.upToDate': 'À jour',
  'app.updateCheck.newVersionAvailable':
    '{count} nouvelle{count, plural, =1 {} other {s}} mise{count, plural, =1 {} other {s}} à jour disponible{count, plural, =1 {} other {s}}',
  'app.updateCheck.allUpToDate': 'Tous les composants sont à jour',
  'app.updateCheck.viewRelease': 'Voir la version',
  'app.updateCheck.recheck': 'Vérifier à nouveau',
  'app.updateCheck.close': 'Fermer',
  'app.updateCheck.failed':
    'Échec de la vérification des mises à jour, veuillez réessayer plus tard',
};
